<template>
  <div class="returns">
    <WordpressContentPage :pageSlug="'returns-content'"/>
    <form class="returnForm row mx-auto" v-on:submit.prevent="submitReturn">

      <div class="returnField col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <label class="col-12">Brand*: </label>
        <input
          v-focus
          v-model="brand"
          type="text"
          name="Brand"
          v-validate="'required'"
          class="col-12 form-control"
        >
        <div class="invalid-feedback">{{errors.first('Brand')}}</div>
      </div>

      <div class="returnField col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <label class="col-12">Product Name*: </label>
        <input
          v-focus
          v-model="productName"
          type="text"
          name="Product Name"
          v-validate="'required'"
          class="col-12 form-control"
        >
        <div class="invalid-feedback">{{errors.first('Product Name')}}</div>
      </div>

      <div class="returnField col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <label class="col-12">Product Description*: </label>
        <textarea
          v-focus
          v-model="productDesc"
          type="text"
          name="Product Description"
          v-validate="'required'"
          class="col-12 form-control"
        ></textarea>
        <div class="invalid-feedback">{{errors.first('Product Description')}}</div>
      </div>

      <div class="returnField col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <label class="col-12">Reason for Return*: </label>
        <div class="radioButtons col-12">
          <label for="reason1" class="col-6">Change of Mind</label>
          <input type="radio" v-model="reason"  value="Change of Mind" id="reason1" name="Reason" class="col-2" v-validate="'required'">
          <label for="reason2" class="col-6">Faulty</label>
          <input type="radio" v-model="reason" value="Faulty" id="reason2" name="Reason" class="col-2">
          <label for="reason3" class="col-6">Wrong Product Supplied</label>
          <input type="radio" v-model="reason" value="Wrong Product Supplied" id="reason3" name="Reason" class="col-2">
          <label for="reason4" class="col-6">Other</label>
          <input type="radio" v-model="reason" value="Other" id="reason4" name="Reason" class="col-2">
        </div>
        <div class="invalid-feedback">{{errors.first('Reason')}}</div>
      </div>

      <div v-if="reason=='Other'" class="returnField col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <label class="col-12">Issue Description*: </label>
        <textarea
          v-focus
          v-model="issueDesc"
          type="text"
          name="Issue Description"
          v-validate="'required'"
          class="col-12 form-control"
        ></textarea>
        <div class="invalid-feedback">{{errors.first('Issue Description')}}</div>
      </div>
      <div class="row col-12">

        <ButtonWithLoading
        class="mx-auto col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4"
        type="submit"
        :state="(this.returnsForm) ? 'success' : submitState"
        text="Submit"
        loadingText="Submitting"
        successText="Submitted"
        errorText="Error Submitting"
        ></ButtonWithLoading>
      </div>
      <div class="row col-12">
        <small class="mx-auto col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">* = Required</small>
      </div>

    </form>
  </div>
</template>

<script>

import ButtonWithLoading from "@/components/buttonWithLoading";
import WordpressContentPage from "@/wordpress/WordpressContentPage";

import { fetchUserDetails, postReturns } from '@/network/userRequests'
import { mapState } from "vuex";

export default {
  name: 'Returns',
  components: {
    ButtonWithLoading,
    WordpressContentPage
  },
  data(){
    return{
      loading: null,
      submitState: null,
      user: null,
      brand: '',
      productName: '',
      productDesc: '',
      reason: '',
      issueDesc: ''
    }
  },
  mounted(){
    this.getData()

  },
  methods: {
    getData() {
      this.loading = true;
      fetchUserDetails(userDetails => {
        this.user = userDetails.member_details;
        // console.log(this.user)
        this.loading = false;
      });
    },
    submitReturn() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }
        this.submitState = "loading";
        let name = this.user.given_name + " " + this.user.family_name;
        let email = this.user.email;
        let homephone = this.user.home_phone
        let cellphone = this.user.cellphone
        let member_id = this.user.account_id_fk
        if (this.reason != "Other") {
          this.issueDesc = "";
        }
        const { brand, productName, productDesc, reason, issueDesc } = this
        postReturns({name, email, homephone, cellphone, member_id, brand, productName, productDesc, reason, issueDesc},
          success=>{ //success
            // console.log(success)
            this.submitState = "success";
            setTimeout(() => {
              this.submitState = null;
            }, 5000);
          },
          error =>{
            this.submitState = "error";
            setTimeout(() => {
              this.submitState = null;
            }, 2000);
            // console.log(error);
        })
      })
    }
  },
  computed: {
    ...mapState({
      returnsForm: state => state.misc.returns_form
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
